// Product pages "where to buy" button
// Destini code lives in _layouts/default.twig
// Helper button lives in templates/pages/_product.twig
const destiniHelperButton = document.querySelectorAll(".js-destini");

if (destiniHelperButton.length > 0) {
  const shadowEl = document.querySelector(".destini-locator-class");
  destiniHelperButton.forEach((btn) => {
    btn.addEventListener("click", () => {
      const shadowButton = shadowEl?.shadowRoot.querySelector(
        ".chakra-portal .chakra-button",
      );
      if (shadowButton) {
        shadowEl.classList.remove("invisible");
        shadowButton.click();
      } else {
        const fallbackUrl = btn.dataset.fallback;
        if (fallbackUrl) {
          window.open(fallbackUrl);
        }
      }
    });
  });
}
